import React from 'react'
import {Label} from '../../../Components/Atoms/Forms'
import {Baseline} from '../../../Components/Layout/Grid'
import {DatePicker} from '../../../sharedComponents/components'

type DatePicker = {
  startDate: Date
  endDate: Date
}

interface MessageSchedulerProps {
  t: any
  datePicker: DatePicker
  handleDateChange: (name: string, value: Date) => void
  locale: string
}

export const MessageScheduler = ({t, datePicker, handleDateChange, locale}: MessageSchedulerProps) => {
  return (
    <Baseline>
      <Label required>{t('messages:labels.activePeriod', 'Active Period')}</Label>
      <DatePicker
        id="activePeriod"
        onChange={handleDateChange}
        startDate={datePicker.startDate}
        minDateForEndingDate={datePicker.startDate}
        minDateForStartingDate={new Date()}
        endDate={datePicker.endDate}
        locale={locale}
      />
    </Baseline>
  )
}
